/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Načítání...',
	'dlg_close': 'Zavřít',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Storno',
	'dlg_back': 'Přejít zpět',

	// Slider
	'sliderRegionLabel': 'Posuvný ovládací prvek, k posunu jezdce použijte šipky vpravo a vlevo.',
	'sliderHandleLabel': 'Jezdec',
	'a11ySliderHandleLabel': 'Jezdec %{sliderValue}',
	'sliderInputLabel': 'hodnota',

	// Side bar
	'sidebarAdd': 'Přidat',
	'clearTextFilterValue': 'Vymazat',
	'missingDataSetData': 'Data pro tuto datovou sadu nejsou k dispozici. Aktualizujte datovou sadu nebo požádejte administrátora o přístup ke zdroji.',

	// Toolbar
	'toolbarRegionLabel': 'Panel nástrojů',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Rodina písem',
	'fontSizeSelect': 'Velikost písma',
	'bold': 'Tučně',
	'italic': 'Kurzíva',
	'underline': 'Podtržení',
	'justifyLeft': 'Zarovnat vlevo',
	'justifyCenter': 'Zarovnat na střed',
	'justifyRight': 'Zarovnat vpravo',
	'insertOrderedList': 'Seřazený seznam',
	'insertUnorderedList': 'Neseřazený seznam',
	'fontColorPicker': 'Výběr barvy',
	'textWrap': 'Zalomit text',
	'restore': 'Obnovit výchozí nastavení',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Počet výsledků',
	'topbottomPercentLabel': 'Procenta',
	'topbottomNumberOfResultsLimit': 'Hodnota může být z rozmezí %{lower} - %{higher}',
	'topbottomSelectOption': 'Volba Začátek nebo konec',
	'topbottomOptionLabel': 'Zobrazit',
	'searchByLabel': 'Podle',
	'searchNoMatches': 'Nebyly nalezeny žádné odpovídající položky',
	'topbottomRankColumnLabel': 'Přidat sloupec očíslování pořadí do tabulky',
	'topbottomNone': 'Žádný',
	'topCount': 'Horní počet',
	'topPercent': 'Horní %',
	'bottomCount': 'Dolní počet',
	'bottomPercent': 'Dolní %',
	'searchColumn': 'Najít sloupec',
	'searchColumnAriaLabel': 'Můžete hledat sloupec. Zadejte název sloupce, který chcete hledat, a poté pomocí šipky dolů najděte příslušný sloupec v seznamu.',
	'rankColumnLabel': 'Pořadí (%{columnLabel})',
	'topbottomClearLabel': 'Vymazat',

	// Format
	'formatAuto': 'Automaticky',
	'formatConvertPercent': 'Převést desetinné číslo na procentní část',
	'formatAbbreviate': 'Zkracovat',
	'formatUseGrouping': 'Použít oddělovač tisíců',
	'dateStyle': 'Styl data',
	'dateTimeStyle': 'Styl data/času',
	'formatMissingValueCharactersInfo': 'Znaky pro chybějící hodnotu určují znaky, které budou zobrazeny, pokud hodnota chybí.',
	'currencySymbolLabel': 'Symbol měny',
	'customSymbolPlaceholder': 'Přidat symbol',
	'customSymbolLabelInfo': 'Určuje znak nebo znaky, které se použijí jako vlastní symbol. Tento symbol se uvádí před číslem a případným znaménkem.',
	'numberLabel': 'Popisek čísla',
	'numberPositionLabel': 'Poloha popisku',
	'numberLabelInfo': 'Určuje popisek pro formátované číslo, který se na základě polohy popisku umístí jako předpona nebo přípona.',
	'nullValueDefault': '<výchozí>',
	'nullValueContent': '(bez hodnoty)',
	'default': 'Výchozí',
	'beginning': 'Začátek',
	'end': 'Konec',

	// More data indicator
	'moreDataIndicator': 'Vaše data byla oříznuta po %{threshold} položkách. Chcete-li zobrazit méně položek, použijte filtr.',

	// Expanded View / Focus mode
	'evCollapse': 'Sbalit',
	'duplicate': 'Duplikovat',
	'copyOf': 'Kopie %{name}',
	'unableToDuplicateBoard': 'Nelze duplikovat "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Nelze načíst objekty.',

	// Custom widgets
	'customWidget': 'Vlastní modul widget'
});
